// import { filter } from "lodash";
import { sentenceCase } from "change-case";
import { useState, forwardRef, useEffect, useRef } from "react";
import { Icon } from "@iconify/react";
import plusFill from "@iconify/icons-eva/plus-fill";
import pinFill from "@iconify/icons-eva/pin-fill";
import { useNavigate, useLocation, useSearchParams } from "react-router-dom";
import CheckIcon from "@mui/icons-material/Check";
import AccountTreeRoundedIcon from "@mui/icons-material/AccountTreeRounded";
import DoNotDisturbAltIcon from "@mui/icons-material/DoNotDisturbAlt";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import roundAccountTree from "@iconify/icons-ic/round-account-tree";
import ClearIcon from "@mui/icons-material/Clear";
import { Portal } from "@mui/base";
// import * as Yup from "yup";
// material
import {
  Card,
  Table,
  Stack,
  // Avatar,
  Button,
  TextField,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  TablePagination,
  Divider,
  Box,
  Chip,
  FormControl,
  InputLabel,
  Select,
  FormHelperText,
  MenuItem,
  OutlinedInput,
  Link,
} from "@mui/material";
// components
import Page from "../components/Page";
import Label from "../components/Label";
import Scrollbar from "../components/Scrollbar";
import CloseIcon from "@mui/icons-material/Close";
import {
  LocationListHead,
  LocationListToolbar,
  LocationMoreMenu,
} from "../components/_dashboard/location";
import { filter } from "lodash";
import { sort } from "fast-sort";
//
// import LOCATIONLIST from "../_mocks_/location";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Slide from "@mui/material/Slide";
import Pagination from "@mui/material/Pagination";
import LinearProgress from "@mui/material/LinearProgress";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import { CallApi } from "../statics.js";

const Alert = forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function SlideTransition(props) {
  return <Slide {...props} direction="left" />;
}
// ----------------------------------------------------------------------
function applySortFilter(array, order, orderBy, query) {
  let list = array;
  let result = [];
  if (order === "asc") {
    result = sort(list).by([
      {
        asc: (u) => {
          if (typeof u[orderBy] === "string" || u[orderBy] instanceof String)
            return u[orderBy].toLowerCase();
          else return u[orderBy];
        },
      },
      { asc: (u) => u.createdAt },
    ]);
  } else {
    result = sort(list).by([
      {
        desc: (u) => {
          if (typeof u[orderBy] === "string" || u[orderBy] instanceof String)
            return u[orderBy].toLowerCase();
          else return u[orderBy];
        },
      },
      { desc: (u) => u.createdAt },
    ]);
  }

  if (query) {
    return filter(
      result,
      (_user) => _user.title.toLowerCase().indexOf(query.toLowerCase()) !== -1
    );
  }

  return result;
}

const TABLE_HEAD = [
  { id: "title", label: "Title", alignRight: false },
  { id: "lineTitle", label: "Product", alignRight: false },
  // { id: "dimensionType", label: "Dimension Type", alignRight: false },
  { id: "descr", label: "Description", alignRight: false },
  // { id: "createdAt", label: "Date & Time", alignRight: false },
  { id: "items", label: "Items", alignRight: false },
  { id: "" },
];

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

export default function Models() {
  const [page, setPage] = useState(0);
  const [totalItems, setTotalItems] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [open, setOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackType, setSnackType] = useState(false);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [buttonDisabled, setButtonDisabled] = useState(false);
  const [infoDialogOpen, setInfoDialogOpen] = useState(false);
  const [currentLocItem, setCurrentLocItem] = useState({ title: "" });
  const [actionMode, setActionMode] = useState("accepting");
  const [dialogMode, setDialogMode] = useState("add");
  const [modelTitle, setModelTitle] = useState("");
  const [modelTitleErrorText, setModelTitleErrorText] = useState("");
  const [modelDes, setModelDes] = useState("");
  const [modelDesErrorText, setModelDesErrorText] = useState("");

  const [minHeight, setMinHeight] = useState("");
  const [minHeightErrorText, setMinHeightErrorText] = useState("");
  const [maxHeight, setMaxHeight] = useState("");
  const [maxHeightErrorText, setMaxHeightErrorText] = useState("");
  const [minWidth, setMinWidth] = useState("");
  const [minWidthErrorText, setMinWidthErrorText] = useState("");
  const [maxWidth, setMaxWidth] = useState("");
  const [maxWidthErrorText, setMaxWidthErrorText] = useState("");
  const [obsoletedValue, setObsoletedValue] = useState("");
  const [obsoletedValueErrorText, setObsoletedValueErrorText] = useState("");
  // const [addModelLoading, setAddModelLoading] = useState(false);
  const [addDialogOpen, setAddDialogOpen] = useState(false);

  const [order, setOrder] = useState("desc");
  const [orderBy, setOrderBy] = useState("createdAt");
  const [filterName, setFilterName] = useState("");

  const [dataLoading, setDataLoading] = useState(true);
  const [tableData, setTableData] = useState([]);
  const [productValue, setProductValue] = useState("");
  const [productValueErrorText, setProductValueErrorText] = useState("");
  const [productList, setProductList] = useState([]);
  const [currentModelItem, setCurrentModelItem] = useState({
    id: "",
    title: "",
  });

  const [searchParams, setSearchParams] = useSearchParams();

  const navigate = useNavigate();

  // const modelTitleTextField = useRef(null);

  function getCookie(cname) {
    let name = cname + "=";
    let ca = document.cookie.split(";");
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  useEffect(() => {
    getAllLines();
  }, []);

  const getAllLines = () => {
    let data = {
      username: getCookie("username"),
      token: getCookie("token"),
      page: 0,
      count: 1000,
    };
    setDataLoading(true);
    CallApi("getAllLines", "post", data).then((result) => {
      try {
        if (result.status === 200) {
          setProductList(result.result);
          if (searchParams.get("productId")) {
            let found = false;
            result.result.forEach((element) => {
              if (element._id === searchParams.get("productId")) found = true;
            });
            if (found) {
              setProductValue(searchParams.get("productId"));
              setDialogMode("add");
              setModelTitle("");
              setModelDes("");
              setProductValueErrorText("");
              setModelTitleErrorText("");
              setAddDialogOpen(true);
              setCurrentModelItem({ title: "" });
            }
          }
          getAllModels();
        }
      } catch (error) {
        console.log("error: ", error);
      }
    });
  };

  // useEffect(() => {
  //   if (tableData.length > 0) setDataLoading(false);
  // }, [tableData]);

  const getAllModels = () => {
    let data = {
      username: getCookie("username"),
      token: getCookie("token"),
      page: page,
      count: rowsPerPage,
    };
    console.log(data);
    setDataLoading(true);
    CallApi("getAllModels", "post", data).then((result) => {
      try {
        console.log(result);
        if (result.status === 200) {
          setTableData(result.result);
          setTotalItems(result.paginateInfo.totalItems);
        }
        setDataLoading(false);
      } catch (error) {
        console.log("error: ", error);
        setDataLoading(false);
      }
    });
  };

  const handleChangePage = (e, value) => {
    setPage(value);
  };

  useEffect(() => {
    if (tableData.length > 0) getAllModels();
  }, [page]);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  // const handleFilterByName = (event) => {
  //   setFilterName(event.target.value);
  // };

  // useEffect(() => {
  //   if (addDialogOpen) modelTitleTextField.current.focus();
  // }, [addDialogOpen]);

  const handleClickOpen = () => {
    setDialogMode("add");
    setModelTitle("");
    setModelDes("");
    setProductValue("");
    setProductValueErrorText("");
    setModelTitleErrorText("");
    setAddDialogOpen(true);
    setCurrentModelItem({ title: "" });
  };

  const addModel = () => {
    if (!modelTitle) {
      setModelTitleErrorText("Model title cannot be empty");
      return;
    } else {
      setModelTitleErrorText("");
    }

    if (!productValue) {
      setProductValueErrorText("Product cannot be empty");
      return;
    } else {
      setProductValueErrorText("");
    }

    let data = {
      username: getCookie("username"),
      token: getCookie("token"),
      title: modelTitle ? modelTitle : "",
      descr: modelDes ? modelDes : "",
      lineId: productValue[0],
      pic: "",
    };
    let apiname = "createNewModel";

    if (dialogMode === "update") {
      data = {
        username: getCookie("username"),
        token: getCookie("token"),
        modelId: currentModelItem._id,
        title: modelTitle ? modelTitle : "",
        descr: modelDes ? modelDes : "",
        pic: "",
      };
      apiname = "updateModel";
    }

    console.log(data);
    setButtonDisabled(true);

    CallApi(apiname, "post", data)
      .then((result) => {
        try {
          console.log(result);
          if (result.status === 200) {
            getAllModels();
            setSnackType("success");

            if (apiname === "createNewModel")
              setSnackbarMessage(
                "'" + modelTitle + "' has been added successfully"
              );
            else
              setSnackbarMessage(
                "'" + modelTitle + "' has been updated successfully"
              );

            setSnackbarOpen(true);
            setAddDialogOpen(false);
          } else {
            setSnackType("error");
            setSnackbarMessage(result.message);
            setSnackbarOpen(true);
          }
          setButtonDisabled(false);
        } catch (error) {
          console.log("error: ", error);
        }
      })
      .catch((err) => {
        setSnackType("error");
        setSnackbarMessage(err);
        setSnackbarOpen(true);
        setButtonDisabled(false);
      });
  };

  const onEditItem = (item) => {
    if (!buttonDisabled) {
      console.log(item);
      setCurrentModelItem(item);
      setDialogMode("update");
      setModelTitle(item.title);
      setModelDes(item.descr);
      setProductValue([item.lineId]);
      setModelTitleErrorText("");
      setProductValueErrorText("");
      setAddDialogOpen(true);
    }
  };

  const onDeleteItem = (item) => {
    if (!buttonDisabled) {
      setCurrentModelItem(item);
      setDeleteDialogOpen(true);
    }
  };

  const handleChangeProduct = (event) => {
    const {
      target: { value },
    } = event;
    setProductValue(typeof value === "string" ? value.split(",") : value);
  };

  const confirmDeleteItem = () => {
    setDeleteDialogOpen(false);

    let data = {
      username: getCookie("username"),
      token: getCookie("token"),
      modelId: currentModelItem._id,
    };

    console.log(data);

    setButtonDisabled(true);
    CallApi("removeModel", "post", data)
      .then((result) => {
        try {
          console.log(result);
          if (result.status === 200) {
            getAllModels();
          }
          setButtonDisabled(false);
        } catch (error) {
          console.log("error: ", error);
        }
      })
      .catch((err) => {
        setSnackType("error");
        setSnackbarMessage(err);
        setSnackbarOpen(true);
        setButtonDisabled(false);
      });
  };

  const filteredDataList = applySortFilter(
    tableData,
    order,
    orderBy,
    filterName
  );

  const isUserNotFound = filteredDataList.length === 0;

  return (
    <Page title="Models | Admin Panel">
      {dataLoading && (
        <LinearProgress
          color="primary"
          sx={{
            ml: -2,
            zIndex: "100000",
            width: "100%",
            position: "fixed",
            top: "0px",
          }}
        />
      )}
      {!dataLoading && (
        <Container sx={{ position: "relative" }}>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            mb={5}
          >
            <Typography variant="h4" gutterBottom>
              Models
            </Typography>
            <Button
              onClick={handleClickOpen}
              variant="contained"
              // component={RouterLink}
              // to="new"
              // state={{ type: "new" }}
              disabled={buttonDisabled}
              startIcon={<Icon icon={plusFill} />}
            >
              New Model
            </Button>
          </Stack>

          <Card>
            {/* <LocationListToolbar
              filterName={filterName}
              searchPlaceHolder="Search title..."
              onFilterName={handleFilterByName}
            /> */}
            <Scrollbar>
              <TableContainer sx={{ minWidth: 800 }}>
                <Table>
                  <LocationListHead
                    headLabel={TABLE_HEAD}
                    rowCount={filteredDataList.length}
                    order={order}
                    orderBy={orderBy}
                    onRequestSort={handleRequestSort}
                  />
                  {!isUserNotFound && (
                    <TableBody>
                      {filteredDataList.map((row) => {
                        const { _id, title, descr, lineTitle } = row;

                        return (
                          <TableRow hover key={_id} tabIndex={-1}>
                            <TableCell
                              component="th"
                              scope="row"
                              padding="normal"
                            >
                              <Typography variant="subtitle2" noWrap>
                                {title}
                              </Typography>
                            </TableCell>
                            <TableCell>{lineTitle}</TableCell>
                            {/* <TableCell>{dimensionTypeTitle}</TableCell> */}
                            <TableCell>{descr ? descr : "-"}</TableCell>
                            {/* <TableCell>{createdAt}</TableCell> */}

                            <TableCell align="left">
                              <Link href={"/models/" + _id}>
                                <Box
                                  component={Icon}
                                  icon={roundAccountTree}
                                  sx={{
                                    color: "primary.main",
                                    width: 24,
                                    height: 24,
                                    cursor: "pointer",
                                  }}
                                />
                              </Link>
                            </TableCell>

                            {/* <TableCell align="left">
                                <Stack
                                  direction="row"
                                  spacing={0.5}
                                  divider={
                                    <Divider orientation="vertical" flexItem />
                                  }
                                  alignItems="center"
                                >
                                  <Button
                                    variant="outlined"
                                    color="primary"
                                    href={"/models/" + _id}
                                  >
                                    Step
                                  </Button>
                                  <Button
                                    onClick={() => {
                                    }}
                                    variant="outlined"
                                    color="primary"
                                  >
                                    Model
                                  </Button>
                                </Stack>
                              </TableCell> */}
                            <TableCell align="right">
                              <LocationMoreMenu
                                onEdit={() => onEditItem(row)}
                                onDelete={() => onDeleteItem(row)}
                              />
                            </TableCell>
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  )}
                  {isUserNotFound && (
                    <TableBody>
                      <TableRow>
                        <TableCell
                          align="center"
                          colSpan={12}
                          sx={{
                            py: 3,
                            color: "text.disabled",
                            fontSize: "12px",
                          }}
                        >
                          No Data
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  )}
                </Table>
              </TableContainer>
            </Scrollbar>

            <TablePagination
              rowsPerPageOptions={[]}
              component="div"
              count={totalItems}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
            />
          </Card>
        </Container>
      )}
      <Dialog
        sx={{ p: 2, mt: 2 }}
        open={deleteDialogOpen}
        TransitionComponent={Transition}
        // keepMounted
        onClose={() => setDeleteDialogOpen(false)}
      >
        <DialogTitle>Deleting Model</DialogTitle>
        <DialogContent sx={{ maxWidth: "400px" }}>
          <DialogContentText id="alert-dialog-description">
            {"Are you sure for deleting '" + currentModelItem.title + "'?"}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={confirmDeleteItem}>Yes</Button>
          <Button onClick={() => setDeleteDialogOpen(false)} color="secondary">
            No
          </Button>
        </DialogActions>
      </Dialog>

      {/* <Dialog
        sx={{ p: 2, mt: 2 }}
        open={infoDialogOpen}
        TransitionComponent={Transition}
        keepMounted
        onClose={() => {
          setInfoDialogOpen(false);
        }}
      >
        <DialogTitle>
          {"More info about '" + currentLocItem.title + "': "}
        </DialogTitle>

        <DialogContent sx={{ maxWidth: "400px" }}>
          <Stack direction="row" spacing={1} mb={2}>
            <Typography variant="subtitle2">Farm Type: </Typography>
            <Typography variant="paragraph">
              {currentLocItem.farmType}
            </Typography>
          </Stack>
          <Stack direction="row" spacing={1} mb={2}>
            <Typography variant="subtitle2">Address: </Typography>
            <Typography variant="paragraph">
              {currentLocItem.address}
            </Typography>
          </Stack>
          <Stack direction="row" spacing={1} mb={2}>
            <Typography variant="subtitle2">Area: </Typography>
            <Typography variant="paragraph">{currentLocItem.area}</Typography>
          </Stack>

          <Stack direction="row" spacing={1} mb={2}>
            <Typography variant="subtitle2">Latitude: </Typography>
            <Typography variant="paragraph">{currentLocItem.lat}</Typography>
          </Stack>
          <Stack direction="row" spacing={1} mb={2}>
            <Typography variant="subtitle2">Longitude: </Typography>
            <Typography variant="paragraph">{currentLocItem.lon}</Typography>
          </Stack>

          <Stack direction="column" sx={{ width: "100%" }}>
            <Box
              sx={{
                width: "100%",
                minHeight: "1px",
                backgroundColor: "var(--gray2)",
              }}
              mt={3}
              mb={1}
            />
            <Stack
              direction="row"
              alignItems="center"
              justifyContent="flex-end"
            >
              <Button
                onClick={() => {
                  setInfoDialogOpen(false);
                }}
                variant="outlined"
                disabled={buttonDisabled}
                startIcon={<ArrowBackIosIcon />}
              >
                Back
              </Button>
            </Stack>
          </Stack>
        </DialogContent>
      </Dialog> */}

      <Dialog
        sx={{ p: 2, mt: 2 }}
        open={addDialogOpen}
        TransitionComponent={Transition}
        keepMounted
        onClose={() => {
          if (!buttonDisabled) setAddDialogOpen(false);
        }}
      >
        <DialogTitle>
          {dialogMode === "add" ? "Add New Model" : "Edit Model"}
        </DialogTitle>
        <DialogContent sx={{ maxWidth: "400px" }}>
          {/* <Stack direction="row" spacing={1} style={{ alignItems: "center" }}>
            <div
              style={{
                height: "1px",
                backgroundColor: "var(--mainColor)",
                flex: "1",
              }}
            />
            <div>or</div>
            <div
              style={{
                height: "1px",
                backgroundColor: "var(--mainColor)",
                flex: "1",
              }}
            />
          </Stack> */}

          <TextField
            fullWidth
            sx={{ mb: 2, mt: 2 }}
            autoFocus
            type="text"
            label="Title"
            value={modelTitle}
            // inputRef={modelTitleTextField}
            onChange={(e) => setModelTitle(e.target.value)}
            disabled={buttonDisabled}
            // disabled={addModelLoading}
            helperText={modelTitleErrorText}
            error={modelTitleErrorText ? true : false}
          />

          <TextField
            fullWidth
            sx={{ mb: 2 }}
            autoFocus
            type="text"
            label="Description"
            value={modelDes}
            onChange={(e) => setModelDes(e.target.value)}
            disabled={buttonDisabled}
            helperText={modelDesErrorText}
            error={modelDesErrorText ? true : false}
          />

          <FormControl
            sx={{ mb: 2, mt: 1 }}
            fullWidth
            disabled={
              buttonDisabled || (currentModelItem.title !== "" ? true : false)
            }
            error={productValueErrorText ? true : false}
          >
            <InputLabel>Product</InputLabel>
            <Select
              IconComponent={() =>
                productValue &&
                productValue.length > 0 &&
                currentModelItem.title === "" ? (
                  <div
                    style={{
                      marginRight: "10px",
                      padding: "4px",
                      cursor: "pointer",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                    onClick={() => setProductValue("")}
                  >
                    <ClearIcon style={{ fontSize: "20px" }} />
                  </div>
                ) : null
              }
              value={productValue ? productValue : ""}
              onChange={handleChangeProduct}
              input={<OutlinedInput label="Product" />}
              MenuProps={MenuProps}
            >
              {productList.map((pt) => (
                <MenuItem key={pt._id} value={pt._id}>
                  {pt.title}
                </MenuItem>
              ))}
            </Select>
            <FormHelperText>{productValueErrorText}</FormHelperText>
          </FormControl>

          {buttonDisabled && (
            <LinearProgress
              color="primary"
              sx={{
                zIndex: "100000",
                width: "100%",
                position: "absolute",
                bottom: "0px",
                ml: -3,
              }}
            />
          )}
        </DialogContent>
        <DialogActions sx={{ mb: 1 }}>
          <Button
            onClick={addModel}
            variant="contained"
            disabled={buttonDisabled}
          >
            {dialogMode === "add" ? "Add" : "Update"}
          </Button>
          <Button
            onClick={() => setAddDialogOpen(false)}
            color="secondary"
            disabled={buttonDisabled}
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
      <Portal>
        <Snackbar
          open={snackbarOpen}
          onClose={() => setSnackbarOpen(false)}
          TransitionComponent={SlideTransition}
          autoHideDuration={6000}
          anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        >
          <Alert
            onClose={() => setSnackbarOpen(false)}
            severity={snackType}
            sx={{ width: "100%" }}
          >
            {snackbarMessage}
          </Alert>
        </Snackbar>
      </Portal>
    </Page>
  );
}
